import React from 'react';
import { CrudStyles } from '../shared/Crud';

const { StatusBadge } = CrudStyles;

const ellipsis = {
    maxWidth: '280px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
};

/** Colunas alinhadas a CostCenterHeader (id, name, code, active). */
export const COST_CENTER_LIST_COLUMNS = [
    {
        header: 'ID',
        accessor: 'id',
        sortable: false,
        render: (item) => (item?.id != null ? String(item.id) : '—'),
    },
    {
        header: 'Nome',
        accessor: 'name',
        sortable: false,
        render: (item) => (
            <div style={ellipsis} title={item?.name || undefined}>
                {item?.name || '—'}
            </div>
        ),
    },
    {
        header: 'Código',
        accessor: 'code',
        sortable: false,
        render: (item) => (
            <div style={{ ...ellipsis, maxWidth: '140px' }} title={item?.code || undefined}>
                {item?.code || '—'}
            </div>
        ),
    },
    {
        header: 'Status',
        accessor: 'active',
        sortable: false,
        render: (item) => (
            <StatusBadge $active={!!item?.active}>{item?.active ? 'Ativo' : 'Inativo'}</StatusBadge>
        ),
    },
];
